import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { StudentPicker } from "@/components/StudentPicker";
import { HafalanRekap } from "@/components/HafalanRekap";

export default function InputProgress() {
  const [students, setStudents] = useState([]);
  const [sid, setSid] = useState(null);
  const [q, setQ] = useState("");
  const [saved, setSaved] = useState([]);

  const loadSummary = () => api.get("/progress/summary").then((r) => setSaved(r.data.student_ids || [])).catch(() => {});
  useEffect(() => {
    const url = q.trim() ? `/students?search=${encodeURIComponent(q.trim())}` : "/students";
    api.get(url).then((r) => { setStudents(r.data); if (r.data[0] && !q.trim()) setSid((c) => c || r.data[0].id); });
  }, [q]);
  useEffect(() => { loadSummary(); }, []);

  return (
    <div>
      <PageHeader title="Input Hafalan & Capaian" />
      <div className="px-5 pt-4">
        <p className="text-xs text-stone-400 uppercase tracking-wide mb-2">Pilih Siswa</p>
        <input data-testid="hafalan-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari murid kelas lain (opsional)..."
          className="w-full bg-white border border-stone-200 rounded-2xl py-2.5 px-4 mb-3 outline-none focus:border-primary text-sm" />
        <StudentPicker students={students} value={sid} onChange={setSid} savedIds={saved} variant="hafalan" />
        {(() => {
          const st = students.find((x) => x.id === sid);
          return st ? (
            <div data-testid="selected-student-info" className="mt-1 bg-primary/5 border border-primary/20 rounded-2xl px-4 py-3">
              <p className="text-[11px] text-stone-400 uppercase tracking-wide mb-0.5">Sedang menginput untuk</p>
              <p className="font-heading font-bold text-primary text-base leading-tight">{st.name}</p>
              <p className="text-xs text-stone-600 mt-1">Kelas: <span className="font-semibold text-stone-700">{st.kelas || "-"}</span></p>
              <p className="text-xs text-stone-600">Umi Guru: <span className="font-semibold text-stone-700">{st.teacher_name || "-"}</span></p>
            </div>
          ) : null;
        })()}
        <div className="mt-4">
          {sid ? <HafalanRekap studentId={sid} canEdit onSaved={loadSummary} /> : <p className="text-center text-stone-400 mt-8">Belum ada siswa.</p>}
        </div>
        <div className="h-6" />
      </div>
    </div>
  );
}
